import React from 'react';
import { Card } from '@/components/ui/card';
import { CheckCircle, XCircle, AlertCircle, TrendingUp, DollarSign } from 'lucide-react';

export default function PaymentStatsOverview({ paymentStats, totalRevenue }) {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold mb-4 text-muted-foreground uppercase">Payment & Revenue Overview</h2>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        <Card className="p-6 hover:shadow-lg transition-shadow bg-green-50 border-green-200">
          <div className="flex items-center justify-between mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
            <span className="text-xs uppercase font-bold text-green-700">Success Rate</span>
          </div>
          <p className="text-4xl font-black font-heading mb-1 text-green-700">{paymentStats.success_rate}%</p>
          <p className="text-sm text-green-600">Payment Success</p>
        </Card>

        <Card className="p-6 hover:shadow-lg transition-shadow bg-red-50 border-red-200">
          <div className="flex items-center justify-between mb-4">
            <XCircle className="w-8 h-8 text-red-600" />
            <span className="text-xs uppercase font-bold text-red-700">Failed</span>
          </div>
          <p className="text-4xl font-black font-heading mb-1 text-red-700">{paymentStats.failed_payments}</p>
          <p className="text-sm text-red-600">Failed Payments</p>
        </Card>

        <Card className="p-6 hover:shadow-lg transition-shadow bg-orange-50 border-orange-200">
          <div className="flex items-center justify-between mb-4">
            <AlertCircle className="w-8 h-8 text-orange-600" />
            <span className="text-xs uppercase font-bold text-orange-700">Lost</span>
          </div>
          <p className="text-4xl font-black font-heading mb-1 text-orange-700">${paymentStats.lost_revenue.toFixed(2)}</p>
          <p className="text-sm text-orange-600">Lost Revenue</p>
        </Card>

        <Card className="p-6 hover:shadow-lg transition-shadow bg-blue-50 border-blue-200">
          <div className="flex items-center justify-between mb-4">
            <TrendingUp className="w-8 h-8 text-blue-600" />
            <span className="text-xs uppercase font-bold text-blue-700">24H</span>
          </div>
          <p className="text-4xl font-black font-heading mb-1 text-blue-700">{paymentStats.failed_last_24h}</p>
          <p className="text-sm text-blue-600">Failed (24h)</p>
        </Card>

        <Card className="p-6 hover:shadow-lg transition-shadow bg-purple-50 border-purple-200">
          <div className="flex items-center justify-between mb-4">
            <DollarSign className="w-8 h-8 text-purple-600" />
            <span className="text-xs uppercase font-bold text-purple-700">Total Revenue</span>
          </div>
          <p className="text-4xl font-black font-heading mb-1 text-purple-700">${totalRevenue?.toFixed(2) || '0.00'}</p>
          <p className="text-sm text-purple-600">All Time</p>
        </Card>
      </div>
    </div>
  );
}
